var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85714 1.35714C6.85714 0.883756 6.47338 0.5 6 0.5C5.52662 0.5 5.14286 0.883756 5.14286 1.35714V5.64286H0.857143C0.383756 5.64286 0 6.02662 0 6.5C0 6.97338 0.383756 7.35714 0.857143 7.35714H5.14286V11.6429C5.14286 12.1163 5.52662 12.5 6 12.5C6.47338 12.5 6.85714 12.1163 6.85714 11.6429V7.35714H11.1429C11.6163 7.35714 12 6.97338 12 6.5C12 6.02662 11.6163 5.64286 11.1429 5.64286H6.85714V1.35714Z",
    fill: "#0B89CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg40);
export default __webpack_public_path__ + "static/media/svg40.418ef76657a8fed6ae6e7faef88708c0.svg";
export { ForwardRef as ReactComponent };